export { ODataBaseAdapter } from './src/index';
